import { alert_push } from '../redux/actions/notifications';

function Alerts( bugsnag, dispatch ) {
  this.Bugsnag = bugsnag;
  this.dispatch = dispatch;
}

Alerts.prototype.INFO = function( title, message, timeout ) {
  this.dispatch( alert_push( 'info', title, message, timeout ) );
};

Alerts.prototype.WARNING = function( title, exception, timeout ) {

  let message = exception;

  if( exception.statusText !== undefined ) {
    message = exception.statusText;
  }

  this.dispatch( alert_push( 'warning', title, message, timeout ) );
};

Alerts.prototype.CRITICAL = function( title, exception, reportToBugsnag ) {
  const report = reportToBugsnag === undefined ? true : reportToBugsnag;
  let message = exception;

  if( exception.statusText !== undefined ) {
    message = exception.statusText;
  }

  // Makes sure Bugsnag is defined
  if( this.Bugsnag !== undefined && this.Bugsnag !== null && report === true ) {
    this.Bugsnag.notify( {'name':title, 'message': message} );
  }

  this.dispatch( alert_push( 'critical', title, message ) );
};

Alerts.prototype.SUCCESS = function( title, message, timeout ) {
  this.dispatch( alert_push( 'success', title, message, timeout ) );
};

export default Alerts;



// WEBPACK FOOTER //
// ./src/prototypes/Alerts.js